/*
 *
 *  * Copyright(c) 2022 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FilterTagPanelComponent } from './filter-tag-panel.component';
import { FilterTagModule } from '../filter-tag/filter-tag.module';
import { PipesModule } from '../../pipes/pipes.module';

@NgModule({
  declarations: [FilterTagPanelComponent],
  exports: [FilterTagPanelComponent],
  entryComponents: [FilterTagPanelComponent],
  imports: [CommonModule, TranslateModule, FilterTagModule, PipesModule]
})
export class FilterTagPanelModule {}

export { FilterTagPanelComponent };
